import emptyFolder from './emptyFolder';
import {
    getViewFilterForTable,
    TableView,
    isFolderPaused,
    listViewStore,
} from 'owa-mail-list-store';
import { ActionSource } from 'owa-mail-store';
import folderStore from 'owa-folders';
import { MailFolder } from 'owa-graph-schema';
import { action, select } from 'satcheljs/lib/legacy';
import { isDeletedItemsFolderFromAnyMailbox, isDumpsterFolderFromAnyMailbox } from 'owa-mail-store';
import { isBefore } from 'owa-datetime';
import * as Schema from 'owa-graph-schema';

export interface EmptyTableViewState {
    folderToBeEmptied: MailFolder;
}

export default action('emptyTableView')(
    select({
        folderToBeEmptied: tableViewToBeEmptied =>
            folderStore.folderTable.get(tableViewToBeEmptied.tableQuery.folderId),
    })(function emptyTableView(
        tableViewToBeEmptied: TableView,
        isExplicitSoftDelete: boolean,
        actionSource: ActionSource,
        rowKeysToExclude: string[],
        state?: EmptyTableViewState
    ) {
        const { folderToBeEmptied } = state;
        const {
            selectAllModeTimeStamp,
            id,
            serverFolderId,
            totalRowsInView,
        } = tableViewToBeEmptied;

        // Use server folder id for empty table view if it's not deleteditems or junkemail or dumpster.
        // For deleteditems or junkemail or dumpster, they don't support delete all with a viewFilter specified.
        if (
            isDumpsterFolderFromAnyMailbox(folderToBeEmptied.FolderId.Id) ||
            isDeletedItemsFolderFromAnyMailbox(folderToBeEmptied.FolderId.Id) ||
            folderToBeEmptied.DistinguishedFolderId === 'junkemail'
        ) {
            emptyFolder(
                folderToBeEmptied,
                getViewFilterForTable(tableViewToBeEmptied),
                isExplicitSoftDelete,
                actionSource,
                rowKeysToExclude,
                selectAllModeTimeStamp,
                id
            );
        } else {
            // Copy properties from folderToBeEmptied to folder
            const folder: MailFolder = { ...folderToBeEmptied };
            folder.FolderId = <Schema.FolderId>{
                Id: serverFolderId,
            };
            folder.TotalCount = totalRowsInView;

            let clientLastSyncTime = selectAllModeTimeStamp;

            if (isFolderPaused(folderToBeEmptied.FolderId.Id)) {
                const inboxPausedDate = listViewStore.inboxPausedDateTime;

                if (isBefore(inboxPausedDate, selectAllModeTimeStamp)) {
                    clientLastSyncTime = inboxPausedDate;
                }
            }

            emptyFolder(
                folder,
                getViewFilterForTable(tableViewToBeEmptied),
                isExplicitSoftDelete,
                actionSource,
                rowKeysToExclude,
                clientLastSyncTime,
                id
            );
        }
    })
);
